import { render, staticRenderFns } from "./SlotForm.vue?vue&type=template&id=479f62f0&"
import script from "./SlotForm.vue?vue&type=script&lang=js&"
export * from "./SlotForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports